import React from 'react';

//motion
import { motion } from 'framer-motion';

//variants
import { fadeIn } from '../variants';

//image
import Img1 from '../assets/portfolio-img1.png';
import Img2 from '../assets/portfolio-img2.png';
import Img3 from '../assets/portfolio-img3.png';

const Work = () => {
  return (
    <section id='work' className='section'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row gap-x-10'>
          <div
            className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
            {/* text */}
            <motion.div
              variants={fadeIn('right', 0.2)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }}>
              <h2 className='h2 leading-tight text-accent'>
                My Latest <br /> Work.
              </h2>
              <p className='max-w-sm text-justify lg:mb-24 mb-16'>
                Explore a glimpse of my recent projects. Discover the fusion of design ingenuity and practicality.
              </p>
              <a href="https://drive.google.com/drive/folders/1OounzNt0Ue0tcWyFMFjM9iqjvUsh1ju2?usp=sharing" target="_blank" rel="noopener noreferrer">
                <button className='btn btn-sm'>View more projects</button>
              </a>

            </motion.div>


            {/* image */}
            <motion.div
              variants={fadeIn('left', 0.3)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }} className='group relative overflow-hidden rounded-[30px] sm:rounded-[50px] box-shadow-custom'>
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img src={Img1} alt='Project - 1' className='group-hover:scale-125 transition-all duration-500 object-fill w-full h-full' />
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <a href="https://quiqr.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-gradient-2'>React Application</span>
                </a>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <a href="https://quiqr.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-3xl text-white'>QuiQR</span>
                </a>
              </div>
            </motion.div>
          </div>
          <div
            className='flex-1 flex flex-col gap-y-10'>
            {/* image */}
            <motion.div
              variants={fadeIn('left', 0.4)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }} className='group relative overflow-hidden rounded-[30px] sm:rounded-[50px] box-shadow-custom'>
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img src={Img2} alt='Project - 2' className='group-hover:scale-125 transition-all duration-500 object-fill w-full h-full' />
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <a href="https://netflix-clone-by-mire-patel.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-gradient-2'>Front-End Project</span>
                </a>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <a href="https://netflix-clone-by-mire-patel.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-3xl text-white'>Netflix App Clone</span>
                </a>
              </div>
            </motion.div>

            {/* image */}

            <motion.div
              variants={fadeIn('left', 0.5)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }} className='group relative overflow-hidden rounded-[30px] sm:rounded-[50px] box-shadow-custom'>
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img src={Img3} alt='Project - 3' className='group-hover:scale-125 transition-all duration-500 object-fill w-full h-full' />
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <a href="https://weather-forecast-app-wd-05-spb5.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-gradient-2'>JavaScript Project</span>
                </a>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <a href="https://weather-forecast-app-wd-05-spb5.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <span className='text-3xl text-white'>Weather Forecast Application</span>
                </a>
              </div>
            </motion.div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
